import en from "./locales/en-GB.json";

export const resources: Record<string, { translation: Record<string, unknown> }> = {
  "en-GB": { translation: en },
};
